import { put, call } from "redux-saga/effects";
import { signIn } from "../../app/components/signin/helper/signInHelper";
import * as actionTypes from "./actionTypes";

export function* signInSaga(payload) {
  try {
    const response = yield call(signIn, payload.user);
    yield put({ type: actionTypes.SIGN_IN_USER_SUCCESS, response });
  } catch (error) {
    yield put({ type: actionTypes.SIGN_IN_USER_ERROR, error });
  }
}
